module.exports = __webpack_public_path__ + "static/tools-resources-photo-01-fe50189540bdaaede1e53690202a6a20.jpg";